
import {of as observableOf,  Observable } from 'rxjs';

import {refCount, publishReplay, catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

const PROFILE_API_LOCAL = '/json/user-profile.json';
const PROFILE_API_URL = '/secure/profiles/v4/profile';

interface PersonalInfo {
  prefix?: any;
  age?: number;
  firstName?: string;
  middleName?: any;
  lastName?: string;
  suffix?: any;
  preferredName?: string;
  displayName?: string;
  maritalStatus?: any;
  gender?: string;
  dateOfBirth?: string;
  last4Ssn?: string;
  citizenship?: any;
  userStatus?: string;
  permanentResident?: any;
  visaExpiration?: any;
  visaType?: any;
  countryOfBirth?: any;
  employmentStatus?: any;
  employerName?: any;
  position?: any;
  occupation?: any;
  euResidentFlag?: string;
}
export interface Profile {
  personalInfo?: PersonalInfo;
  contactAddresses?: Array<Object>;
  contactChannels?: Array<Object>;
  documents?: Array<Object>;
  universalSSOId?: string;
  deleted?: string;
  userType?: string;
  userSource?: string;
  userStatus?: string;
  loginName?: string;
  preferredLanguage?: Object;
  additionalInfo?: Object;
  employee?: Array<Employer>;
}

interface Employer {
  planId?: string;
  institutionName?: string;
  clientId?: string;
  clientMasterKey?: string;
}
export interface ProfileSvc {
  getProfile(domain): Observable<Profile>;
}
const initialProfile: Profile = {
  personalInfo: {},
  contactAddresses: [{}],
  contactChannels: [{}],
  documents: [{}],
  universalSSOId: '',
  deleted: '',
  userType: '',
  userSource: '',
  userStatus: '',
  loginName: '',
  preferredLanguage: {},
  additionalInfo: {},
  employee: [{}]
};

@Injectable()
export class ProfileService implements ProfileSvc {
  profileObservable: Observable<any>;
  static customApiEndpoint: string = null;

  /**
   * Allow consumers ability to specify custom endpoint
   * @param customApiEndPoint
   */
  public static setCustomApiEndpoint(customApiEndPoint: string): void {
    ProfileService.customApiEndpoint = customApiEndPoint;
  }

  constructor(public http: Http) { }

  getProfile(domain): Observable<Profile> {
    const PROFILE_URL = /localhost/.test(domain) ? PROFILE_API_LOCAL : PROFILE_API_URL;
    const finalProfileUrl =
      ProfileService.customApiEndpoint || `${domain + PROFILE_URL}?${Date.now()}`;

    return (
      this.profileObservable ||
      (this.profileObservable = window['profileObservable'] = this.http
        .get(finalProfileUrl, { withCredentials: true }).pipe(
        map(res => {
          const data: any = res.json();
          const cachedProfile: Profile =
            parseInt(data.responseCode, 10) !== 200
              ? initialProfile
              : (data.profiles[0] as Profile);

          if (parseInt(data.responseCode, 10) === 200) {
            let pInfo = data.profiles[0].personalInfo;
            let sessionProfile: Profile = {};

            if (pInfo) {
              sessionProfile.personalInfo = {};
              sessionProfile.personalInfo.firstName = pInfo.firstName ? pInfo.firstName : null;
              sessionProfile.personalInfo.preferredName = pInfo.preferredName
                ? pInfo.preferredName
                : null;

              if (pInfo.dateOfBirth)
                sessionProfile.personalInfo.age =
                  parseInt(
                    (new Date().getFullYear() - new Date(pInfo.dateOfBirth).getFullYear()) / 10 +
                    '',
                    10
                  ) * 10;
            }
            let pEmployers: [any] = data.profiles[0].employers;
            if (pEmployers) {
              sessionProfile.employee = [];
              const employer = pEmployers.find(e => e.clientMasterKey !== null);
              sessionProfile.employee.push(employer);
            }

            // this.storageService.setItem('CachedProfile', JSON.stringify(sessionProfile));
          }

          return cachedProfile;
        }),
        catchError(() => {
          return observableOf(initialProfile);
        }),
        publishReplay(1),
        refCount(),))
    );
  }
}
